import { ModalContainer } from "../table/table.style";
import Modal from "@mui/material/Modal";
import { ReactComponent as Wave } from "./../../assets/icons/wave.svg";
import { ThemeButton } from "../button";
import { FC, useState } from "react";
import { useResendVerifyEmailMutation } from "../../services";
import toast from "react-hot-toast";

export const EmailVerificationModal: FC<IProps> = ({
  path,
  email,
  modalOpen,
  handleClose,
}) => {
  const [resendEmail] = useResendVerifyEmailMutation();
  const [resending, setResending] = useState(false);
  const getVerificationLink = async () => {
    try {
      setResending(true);
      await resendEmail({ type: path, email }).unwrap();
      toast.success("Verification link sent");
    } catch (e: any) {
      console.error(e);
      let message = e?.data?.message || "Something went wrong";
      toast.error(message);
    } finally {
      setResending(false);
    }
  };

  return (
    <Modal
      disableEnforceFocus
      open={modalOpen as boolean}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ModalContainer>
        <p className="modal-label">Registration successful</p>
        <Wave className="modal-illustration" />
        <h6 className="modal-header">Verify your account</h6>
        <p className="modal-body">
          Check the email you provided and click on the link to verify your
          account.
        </p>
        <ThemeButton
          className="modal-cta-main"
          onClick={() => {
            handleClose();
          }}
        >
          Continue
        </ThemeButton>
        <button
          onClick={getVerificationLink}
          disabled={resending}
          className="modal-cta-secondary"
        >
          {resending ? "Resending" : "Resend verification link"}
        </button>
      </ModalContainer>
    </Modal>
  );
};

interface IProps {
  modalOpen: boolean;
  path: "org" | "user" | "";
  email: string;
  handleClose: () => void;
}
